/* ==========================================================================
   Ozeret -- where live data lives

   These are empty containers, not seed data. `hydrate()` in live.ts refills
   them in place from every server response, and the screens import them
   directly. Nothing here ships with content: the demo world that plants a
   fresh database lives in demo-seed.ts and is only ever read by the server.
   ========================================================================== */

import type {
  Availability, Booking, Cleaner, CleanerReview, House, HouseReview, Notification,
  NotifyPrefs, Occurrence, Recurring, Request, Role, Thread,
} from '../types';

export const CLEANERS: Cleaner[] = [];
export const HOUSES: House[] = [];
export const REQUESTS: Request[] = [];
export const BOOKINGS: Booking[] = [];
export const OCCURRENCES: Occurrence[] = [];

export const RECURRING: Recurring[] = [];
export const THREADS: Thread[] = [];
export const AVAILABILITY: Record<string, Availability> = {};
export const REVIEWS_OF_CLEANERS: Record<string, CleanerReview[]> = {};
export const REVIEWS_OF_HOUSES: Record<string, HouseReview[]> = {};
export const NOTIFICATIONS: Record<Role, Notification[]> = { house: [], cleaner: [] };

/** Per-device for now, so it is not part of the server payload. */
export const NOTIFY_PREFS: NotifyPrefs = {
  channel: 'whatsapp',
  newMatches: true,
  messages: true,
  bookingChanges: true,
  reminderDayBefore: true,
  quietFrom: '21:00',
  quietTo: '07:00',
};
